module.exports = __webpack_public_path__ + "static/img/3823_phase_function_Paper_Points.e870825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3823_phase_function_Paper_Points.png
// module id = tfns
// module chunks = 0